var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 narrow results"},_vm._l((_vm.results.data),function(result){return _c('catalog-results-result',{key:result.id,attrs:{"record":result,"isExpandedDefaultState":_vm.isExpandedResult,"genre":_vm.genre,"song":_vm.song}})}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bab43a88","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/CatalogResultsResults.vue
// module id = 509
// module chunks = 0